'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('highlight', {
    url: '/highlight',
    template: '<highlight></highlight>'
  });
}



// WEBPACK FOOTER //
// ./client/app/highlight/highlight.routes.js